import React from 'react';

import api            from '../../../../../../api';
import Context        from '../../../../../../context';
import successHandler from '../../../../../../utils/successHandler';

import { IItem                } from '../../../../../../types/common.interface';
import { useTranslation       } from 'react-i18next';
import { STATUS_PAY_TO_DRIVER } from '../../../../../../values/dropdownItems';
import {
  CustomView,
  CustomModal,
  CustomButton2,
  CustomRadioButtonGroup,
} from '../../../../../../components';

import './index.scss';

const ChangeStatus: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const { showModal, setShowModal, selectedWithdrawals, setSelectedWithdrawal, getAllWithdrawal } = React.useContext(Context.WithdrawalScreen);

  const [selectedStatus, setSelectedStatus] = React.useState<IItem>();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function onSubmitHandler(): Promise<void> {
    let result: any;
    switch (selectedStatus?.value) {
      case 'SEND_TO_BANK': result = await api.put.administrator.sendToBankManyPayToDriver({withdrawalId: selectedWithdrawals}); break;
      case 'ACCEPT'      : result = await api.put.administrator.acceptManyPayToDriver    ({withdrawalId: selectedWithdrawals}); break;
      case 'REJECT'      : result = await api.put.administrator.rejectManyPayToDriver    ({withdrawalId: selectedWithdrawals}); break;
    }
    if(result?.CODE === 2213){
      setShowModal('NONE');
      successHandler(2010);
      setSelectedWithdrawal([]);
      getAllWithdrawal.refetch();
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomModal
      onClose={() => {setShowModal!("NONE");}}
      open={showModal === "CHANGE_STATUS"}
      minWidth={"40vw"}
      maxWidth={"45vw"}
      maxHeight={"30vh"}
    >
      <h6>{t("changeStatus")}</h6>
      <div style={{ width: "100%", marginTop: "2rem" }}>
        <CustomView.Row className="form-column-row">
          <CustomRadioButtonGroup
            menus={STATUS_PAY_TO_DRIVER}
            selected={selectedStatus as IItem}
            onClick={(event: IItem | null) => setSelectedStatus(event as IItem)}
            canNull={false}
          />
        </CustomView.Row>
        <div style={{ width: "100%", marginTop: "2rem" }}>
          <CustomView.Row className="form-column-row">
            <CustomButton2 title={t("submit")} onClick={onSubmitHandler} />
          </CustomView.Row>
        </div>
      </div>
    </CustomModal>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default ChangeStatus;
